import React, { useEffect } from 'react';
import Loader from '../../utils/Loader';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from './updateAction';
import { connect } from 'react-redux';
import { addOnboardDetails } from '../../redux/profile/profile.actions';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Card from 'react-bootstrap/Card';

const Final = ({ addOnboardDetails, history, phone, email }) => {
	Loader.hide();

	const { register, handleSubmit, watch, errors } = useForm();
	const revealWhatsapp = watch('receiveWhatsappNotification');
	const revealSubscription = watch('isSubscribe');
	const { state, action } = useStateMachine(updateAction);

	// useEffect(() => {
	// 	addOnboardDetails(state?.data);
	// }, [addOnboardDetails, state.data]);

	const onSubmit = (data) => {

		if (!data.email) {
			data['email'] = email;
		}
		if (!data.phone) {
			data['phone'] = phone;
		}

		action(data);
		addOnboardDetails(state?.data);
		// history.push('./step4');
		history.push('/mycourse');
	};

	return (
		<Card>
			<Card.Header className="setup-content" id="final">
				<h3>Almost completed!</h3>
			</Card.Header>
			<Card.Body>

				<form onSubmit={handleSubmit(onSubmit)}>
					<p>
						We will only be sending course and score updates. We will not be sending
						any promotional material
					</p>
					<div className="funkyradio funkyradio-flex">
						<span className="profileError">
							{errors.receiveWhatsappNotification?.type === 'required' &&
								'Whatsapp Notification is required'}
						</span>
						<div className="funkyradio-success">
							<input
								type="radio"
								name="receiveWhatsappNotification"
								id="radio1tt"
								ref={register({
									required: true,
								})}
								value={1}
								defaultChecked={state.data?.receiveWhatsappNotification === '1'}
							/>
							<label htmlFor="radio1tt">Yes</label>
						</div>
						<div className="funkyradio-success">
							<input
								type="radio"
								name="receiveWhatsappNotification"
								value={0}
								defaultChecked={state.data?.receiveWhatsappNotification === '0'}
								ref={register({
									required: true,
								})}
								id="radio2tt"
							/>
							<label htmlFor="radio2tt">No</label>
						</div>
					</div>

					{revealWhatsapp === '1' ||
						(typeof revealWhatsapp === 'undefined' &&
							state.data?.receiveWhatsappNotification === '1') ? (
						<div className="form-group" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="whatsappNumber">
								WhatsApp Number
							</label>
							<input
								type="text"
								className="form-control"
								name="whatsappNumber"
								ref={register({
									required: true,
									pattern: /^[6789]\d{9}$/,
								})}
								defaultValue={state.data?.whatsappNumber || phone}
							/>

							<span className="profileError">
								{errors.whatsappNumber?.type === 'pattern' && 'Incorrect mobile number'}
							</span>
							<span className="profileError">
								{errors.whatsappNumber?.type === 'required' &&
									'Whatsapp number required'}
							</span>
						</div>
					) : null}







					<p>
						Would you like to receive updates (and offers) on our English courses on
						Email and SMS?
					</p>
					<div className="funkyradio funkyradio-flex">
						<span className="profileError">
							{errors.isSubscribe?.type === 'required' && 'Notification is required'}
						</span>
						<div className="funkyradio-success">
							<input
								type="radio"
								name="isSubscribe"
								id="radio21tt"
								ref={register({
									required: true,
								})}
								value={1}
								defaultChecked={state.data?.isSubscribe === '1'}
							/>
							<label htmlFor="radio21tt">Yes</label>
						</div>
						<div className="funkyradio-success">
							<input
								type="radio"
								name="isSubscribe"
								value={0}
								defaultChecked={state.data?.isSubscribe === '0'}
								ref={register({
									required: true,
								})}
								id="radio22tt"
							/>
							<label htmlFor="radio22tt">No</label>
						</div>
					</div>

					{(revealSubscription === '1' ||
						(typeof revealSubscription === 'undefined' &&
							state.data?.isSubscribe === '1')) &&
						!phone ? (
						<div className="form-group" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="phone">
								Phone
							</label>
							<small style={{ paddingLeft: '5px' }}>(optional)</small>
							<input
								type="text"
								className="form-control"
								name="phone"
								ref={register({
									pattern: /^[6789]\d{9}$/,
								})}
								defaultValue={state.data?.phone || state.data?.whatsappNumber}
							/>
							<span className="profileError">
								{errors.phone?.type === 'pattern' && 'Incorrect mobile number'}
							</span>
						</div>
					) : null}

					{(revealSubscription === '1' ||
						(typeof revealSubscription === 'undefined' &&
							state.data?.isSubscribe === '1')) &&
						!email ? (
						<div className="form-group" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="email">
								E-mail
							</label>
							<small style={{ paddingLeft: '5px' }}>(optional)</small>
							<input
								type="text"
								className="form-control"
								name="email"
								ref={register({
									pattern: /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/,
								})}
								defaultValue={state.data?.email}
							/>

							<span className="profileError">
								{errors.email?.type === 'pattern' && 'Incorrect email id'}
							</span>
						</div>
					) : null}


					<button
						aria-label="next"
						className="btn btn-primary btn-md mar-top"
						type="submit"
					>
						Go to My Courses
					</button>
				</form>

				{/* <button
					aria-label="dashboard"
					className="btn btn-success pull-right"
					onClick={() => {
						history.push('/mycourse');
					}}
					type="button"
				>
					Go to My Course
				</button> */}
			</Card.Body>
		</Card>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		addOnboardDetails: (obj) => dispatch(addOnboardDetails(obj)),
	};
};

const mapStateToProps = (state) => {
	const { phone, email } = state.rootReducer.userDetails;
	console.log("userDetails ", state.rootReducer.userDetails)
	return {
		phone,
		email
	};
};

export default compose(withRouter, connect(null, mapDispatchToProps))(Final);
